import { Navigate, useLocation, useParams } from 'react-router-dom';

// Los enlaces viejos /book/:slug (ya enviados a clientes) siguen funcionando y pasan a /app/:slug conservando ?pass= y ?client=
export default function LegacyBookRedirect() {
  const { slug } = useParams();
  const { search } = useLocation();
  return <Navigate to={`/app/${slug}${search}`} replace />;
}
